import type { ComponentType } from "react";
import { useCurrentScreen } from "@auth0/auth0-acul-react";
import EmailIdentifierChallengeScreen from "./screens/EmailIdentifierChallenge";
import PhoneIdentifierChallengeScreen from "./screens/PhoneIdentifierChallenge";
import MfaLoginOptionsScreen from "./screens/MfaLoginOptions";

const SCREENS: Record<string, ComponentType> = {
  "email-identifier-challenge": EmailIdentifierChallengeScreen,
  "phone-identifier-challenge": PhoneIdentifierChallengeScreen,
  "mfa-login-options": MfaLoginOptionsScreen,
};

export default function App() {
  const screenOptions = useCurrentScreen();
  const ScreenComponent = screenOptions?.screen?.name
    ? SCREENS[screenOptions.screen.name]
    : undefined;

  return ScreenComponent ? <ScreenComponent /> : null;
}
